import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35b9b247"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-editor-section mt-4 p-3" }
const _hoisted_2 = { class: "scroll-div" }

import { projectContext } from "../../../blockly/ProjectContext";
import PositionEditorNode from "./PositionEditorNode.vue";
import { PositionEditResult } from "../../../utils/PositionEditResult";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { translation } from "../../../lang/Translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionEditorSection',
  setup(__props) {

const t = translation;
const exclude_ids = [];
// 編集可能なノードのみにまとめる。
// 同じBLOCK_IDのノードが複数ある場合は、同じBLOCKから生成されたコードであり、下位ブロックの位置をかえても位置の書き戻しができない。
const editableNodeList = Array.from(projectContext.nodeList.value).reduce(
  (acc, node: HTMLElement) => {
    if (node.id === "rig" && node.querySelector("#default_camera")) {
      // メインカメラを保つ場合は追加し、デフォルトカメラの場合は追加しない（ブロックをもたない）
      exclude_ids.push(node.dataset.block_id);
    }
    console.log("exclude_ids", exclude_ids);
    // 同じブロックIDを持つノードがない かつ
    // 除外IDリストに入っていない 場合は追加する
    if (
      !acc.find((n: HTMLElement) => n.dataset.block_id === node.dataset.block_id) &&
      !exclude_ids.includes(node.dataset.block_id)
    ) {
      acc.push(node);
    }
    return acc;
  },
  [] as Node[]
);

const save = () => {
  const result = editableNodeList.map(
    (node) => new PositionEditResult(node as HTMLElement)
  );
  projectContext.positionEditResult.value = result;
};
const saveWithDialog = () => {
  save();
  MessageDialog.info(
    t.to(
      `現在の位置を保存しました。ブロック画面で保存した位置の反映を行ってください`,
      "save_position_complete"
    )
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: saveWithDialog
      }, _toDisplayString(_unref(t).to("保存", "save")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableNodeList), (node) => {
        return (_openBlock(), _createElementBlock("div", {
          key: node.nodeName
        }, [
          _createVNode(PositionEditorNode, {
            node: node,
            class: "my-1",
            save: save
          }, null, 8, ["node"])
        ]))
      }), 128))
    ])
  ]))
}
}

})